import { useClickOutsideListener } from '../hooks/index.js'
import { useRef, useState } from 'react'
import classnames from 'classnames'

export const SortByControl = (props = {}) => {
    const {
        label = 'Sort by',
        id,
        name,
        value = 'date',
        onChange
    } = props;

    const [isActive, setIsActive] = useState(props.isActive || false)

    const wrapperRef = useRef(null)

    useClickOutsideListener(wrapperRef, () => setIsActive(false))

    return (
        <div className="mr-4 relative" ref={wrapperRef}>
            <button className={classnames(
                'grid-col-2-maxcontent',
                'inline-grid',
                'items-center',
                'p-2',
                'cursor-pointer',
                'focus:outline-none',
                {
                    'transition-all': !isActive,
                    'duration-300': !isActive,
                    'rounded-md': !isActive,
                    'text-blue': !isActive,
                    'hover:bg-opacity-5': !isActive,
                    'hover:bg-black': !isActive,
                    'rounded-t-md': isActive,
                    'bg-blue': isActive,
                    'text-white': isActive
                }
            )} onClick={() => setIsActive(isActive => !isActive)}>
                <label id="listbox-label" className="block font-semibold text-base cursor-pointer">{label}</label>
                <svg className="fill-current h-4 ml-2 w-4 cursor-pointer" aria-hidden="true" viewBox="0 0 52 52">
                    <path xmlns="http://www.w3.org/2000/svg"
                        d="M47.6 17.8L27.1 38.5c-.6.6-1.6.6-2.2 0L4.4 17.8c-.6-.6-.6-1.6 0-2.2l2.2-2.2c.6-.6 1.6-.6 2.2 0l16.1 16.3c.6.6 1.6.6 2.2 0l16.1-16.2c.6-.6 1.6-.6 2.2 0l2.2 2.2c.5.6.5 1.5 0 2.1z">
                    </path>
                </svg>
            </button>
            <div className={classnames(
                'grid',
                'border',
                'border-blue',
                'bg-white',
                'absolute',
                'z-50',
                {
                    hidden: !isActive
                }
            )}>

                <label
                    className="cursor-pointer flex hover:bg-black hover:bg-opacity-5 items-center p-2 transition-all duration-300"
                    onClick={(e) => { onChange('featured') }}>
                    <input
                        type="radio"
                        checked={value === 'featured'}
                        className="h-4 w-4 text-blue focus:ring-blue border-gray checked:border-blue rounded-sm checked:rounded"
                        value="featured"

                    />
                    <span className="ml-4 block text-base text-gray-black whitespace-nowrap">Featured</span>
                </label>


                <label
                    className="cursor-pointer flex hover:bg-black hover:bg-opacity-5 items-center p-2 transition-all duration-300"
                    onClick={(e) => { onChange('alphabetical') }}>
                    <input
                        type="radio"
                        checked={value === 'alphabetical'}
                        className="h-4 w-4 text-blue focus:ring-blue border-gray checked:border-blue rounded-sm checked:rounded"
                        value="alphabetical"

                    />
                    <span className="ml-4 block text-base text-gray-black whitespace-nowrap">A to Z</span>
                </label>

                <label
                    className="cursor-pointer flex hover:bg-black hover:bg-opacity-5 items-center p-2 transition-all duration-300"
                    onClick={(e) => { onChange('alphabetical-reverse') }}>
                    <input
                        type="radio"
                        checked={value === 'alphabetical-reverse'}
                        className="h-4 w-4 text-blue focus:ring-blue border-gray checked:border-blue rounded-sm checked:rounded"
                        value="alphabetical-reverse"

                    />
                    <span className="ml-4 block text-base text-gray-black whitespace-nowrap">Z to A</span>
                </label>

                <label
                    className="cursor-pointer flex hover:bg-black hover:bg-opacity-5 items-center p-2 transition-all duration-300"
                    onClick={(e) => { onChange('date-desc') }}>
                    <input
                        type="radio"
                        checked={value === 'date-desc'}
                        className="h-4 w-4 text-blue focus:ring-blue border-gray checked:border-blue rounded-sm checked:rounded"

                    />
                    <span className="ml-4 block text-base text-gray-black whitespace-nowrap">Date (Newest first)</span>
                </label>

                <label
                    className="cursor-pointer flex hover:bg-black hover:bg-opacity-5 items-center p-2 transition-all duration-300"
                    onClick={(e) => { onChange('date-asc') }}>
                    <input
                        type="radio"
                        checked={value === 'date-asc'}
                        className="h-4 w-4 text-blue focus:ring-blue border-gray checked:border-blue rounded-sm checked:rounded"

                    />
                    <span className="ml-4 block text-base text-gray-black whitespace-nowrap">Date (Oldest first)</span>
                </label>
            </div>

        </div>
    )
}

export default SortByControl